<template>

    <div class="mobile-menu">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M18.8129 8.80562V1.1835C18.0597 1.06274 17.2871 1 16.4998 1C16.0571 1 15.619 1.01985 15.1863 1.05869L15.0926 5.53171C15.0663 6.79065 14.0382 7.79746 12.7789 7.79746H4.21271C2.81077 10.0292 2 12.6699 2 15.4999C2 16.1604 2.04416 16.8105 2.12968 17.4476H7.5352C8.05443 17.4476 8.47534 17.0267 8.47534 16.5074V14.4166C7.66802 14.1229 7.09144 13.3487 7.09144 12.4399C7.09144 11.2786 8.03289 10.3371 9.19423 10.3371C10.3556 10.3371 11.297 11.2786 11.297 12.4399C11.297 13.3725 10.6899 14.1633 9.8494 14.4386V16.5074C9.8494 17.7855 8.81329 18.8216 7.5352 18.8216H2.38225C2.65839 19.9998 3.07819 21.1226 3.62216 22.1706H10.3943C11.6724 22.1706 12.7085 23.2067 12.7085 24.4848V29.4992C13.917 29.8257 15.1881 29.9999 16.4998 29.9999C23.1382 29.9999 28.7346 25.5388 30.4548 19.4511H26.999C26.6408 19.4511 26.3428 19.7263 26.3142 20.0833L26.1187 22.5277C26.033 23.5989 25.1388 24.4245 24.0642 24.4245H20.223C19.9384 25.2485 19.1558 25.8404 18.235 25.8404C17.0736 25.8404 16.1322 24.8989 16.1322 23.7376C16.1322 22.5763 17.0736 21.6348 18.235 21.6348C19.1557 21.6348 19.9382 22.2265 20.2229 23.0504H24.0642C24.4224 23.0504 24.7205 22.7752 24.749 22.4182L24.9445 19.9738C25.0302 18.9026 25.9244 18.077 26.999 18.077H30.7714C30.9214 17.2407 30.9997 16.3794 30.9997 15.4999C30.9997 15.1472 30.9871 14.7974 30.9623 14.4509H25.0151C24.7305 15.2751 23.9479 15.8671 23.027 15.8671C21.8656 15.8671 20.9242 14.9256 20.9242 13.7643C20.9242 12.6029 21.8656 11.6615 23.027 11.6615C23.9476 11.6615 24.73 12.2531 25.0148 13.0769H30.7981C30.5926 11.8551 30.2342 10.6851 29.7434 9.58735H26.1728C24.8947 9.58735 23.8586 8.55125 23.8586 7.27316V3.00344C22.7247 2.33424 21.4917 1.81499 20.187 1.47296V8.80562C20.187 9.94392 19.2642 10.8667 18.1259 10.8667H17.0042C16.6248 10.8667 16.3172 11.1743 16.3172 11.5537V15.3414C17.1936 15.595 17.8344 16.4034 17.8344 17.3615C17.8344 18.5229 16.893 19.4643 15.7316 19.4643C14.5703 19.4643 13.6288 18.5229 13.6288 17.3615C13.6288 16.479 14.1725 15.7235 14.9432 15.4116V11.5537C14.9432 10.4154 15.8659 9.49264 17.0042 9.49264H18.1259C18.5053 9.49264 18.8129 9.18505 18.8129 8.80562ZM13.808 1.2494C10.344 1.8997 7.31451 3.78176 5.19152 6.4234H12.7789C13.2905 6.4234 13.7082 6.01439 13.7189 5.50295L13.808 1.2494ZM25.2327 3.92373V7.27316C25.2327 7.79238 25.6536 8.2133 26.1728 8.2133H29.0386C28.0656 6.54252 26.7682 5.0839 25.2327 3.92373ZM11.3345 29.0528C8.50151 27.9724 6.09447 26.0293 4.43451 23.5447H10.3943C10.9136 23.5447 11.3345 23.9656 11.3345 24.4848V29.0528ZM8.32086 12.4399C8.32086 11.9575 8.71188 11.5665 9.19423 11.5665C9.67658 11.5665 10.0676 11.9575 10.0676 12.4399C10.0676 12.9223 9.67658 13.3133 9.19423 13.3133C8.71188 13.3133 8.32086 12.9223 8.32086 12.4399ZM14.8583 17.3615C14.8583 16.8792 15.2493 16.4882 15.7316 16.4882C16.214 16.4882 16.605 16.8792 16.605 17.3615C16.605 17.8439 16.214 18.2349 15.7316 18.2349C15.2493 18.2349 14.8583 17.8439 14.8583 17.3615ZM17.3616 23.7376C17.3616 23.2552 17.7526 22.8642 18.235 22.8642C18.7173 22.8642 19.1084 23.2552 19.1084 23.7376C19.1084 24.22 18.7173 24.611 18.235 24.611C17.7526 24.611 17.3616 24.22 17.3616 23.7376ZM23.027 12.8909C22.5446 12.8909 22.1536 13.2819 22.1536 13.7643C22.1536 14.2466 22.5446 14.6376 23.027 14.6376C23.5093 14.6376 23.9003 14.2466 23.9003 13.7643C23.9003 13.2819 23.5093 12.8909 23.027 12.8909Z"
                  fill="white"/>
        </svg>
        <a class="mobile-menu__button" @click="toggleMobileMenu">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6H21M3 11.5H21M3 17H21" stroke="white" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </a>
        <transition name="menu">
            <div class="sidebar__wrapper" v-if="isMobileMenuOpen">
                <Sidebar
                    v-if="isMobileMenuOpen"
                    @reset-app="logout"
                />
            </div>
        </transition>
    </div>

    <transition name="shadow">
        <div class="mobile-menu__shadow" v-if="isMobileMenuOpen" @click="toggleMobileMenu"></div>
    </transition>

</template>

<script lang="ts">
import {defineComponent, computed, onMounted} from "vue";
import {collapsed, toggleSidebar, closeSidebar} from "@/core/sidebarState";
import Sidebar from "@/components/ui/sidebar.vue";
import {useStore} from "vuex";

export default defineComponent({
    name: "MobileMenu",
    components: {Sidebar},
    setup(_, ctx) {

        const logout = () => {
            ctx.emit("resetApp", "logout-link");
        };
        const store = useStore();
        const isMobileMenuOpen = computed<boolean>(() => store.getters.getMobileMenuIsOpen);

        const toggleMobileMenu = () => {
            store.commit('setMobileMenuIsOpen', !isMobileMenuOpen.value);
            if (collapsed.value) {
                toggleSidebar();
            }
        }

        onMounted(() => {
            store.commit('setMobileMenuIsOpen', false);
            closeSidebar();
        })

        return {
            toggleSidebar,
            toggleMobileMenu,
            isMobileMenuOpen,
            logout
        };
    }
})
</script>

<style scoped>
.mobile-menu__shadow {
    background-color: rgba(0, 0, 0, 0.3);
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 56px;
    z-index: 11;
    transition: .3s;
}

.mobile-menu {
    display: flex;
    background-color: var(--primary);
    padding: 12px 16px;
    align-items: center;
    position: relative;

    @media (min-width: 769px) {
        display: none;
    }
}

.dark .mobile-menu {
    background-color: var(--dark-bg-600);
}

.sidebar__wrapper {
    position: absolute;
    top: 55px;
    right: 0;
    height: 100vh;
    background-color: var(--primary);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 12;
    transition: .3s;
}

.dark .sidebar__wrapper {
    background: var(--dark-bg-800);
}

.mobile-menu__button {
    margin-left: auto;
    display: block;
    width: 24px;
    height: 24px;
}

.menu-enter-active,
.menu-leave-active {
    transition: transform 0.5s ease, opacity 0.5s ease;
}

.menu-enter-from {
    transform: translateX(100%);
    opacity: 0;
}

.menu-enter-to {
    transform: translateX(0);
    opacity: 1;
}

.menu-leave {
    transform: translateX(0);
    opacity: 1;
}

.menu-leave-to {
    transform: translateX(100%);
    opacity: 0;
}

.shadow-enter-active {
    transition: opacity .5s ease;
}

.shadow-leave-active {
    transition: opacity .5s ease;
}

.shadow-enter-from {
    opacity: 0;
}

.shadow-enter-to {
    opacity: 1;
}

.shadow-leave {
    opacity: 1;
}

.shadow-leave-to {
    opacity: 0;
}
</style>
  